
import { Comment } from '../types/comment';
import PostHeader from './PostHeader';
import { createPostFromComment, formatTime } from './PostUtils';
import MediaDisplay from './MediaDisplay';
import CommentBubble from './CommentBubble';
import ReplySection from './ReplySection';

interface PostViewProps {
  comment: Comment;
}

const PostView = ({ comment }: PostViewProps) => {
  // Créer un objet post à partir du commentaire
  const post = createPostFromComment(comment);
  
  if (!post) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-6 bg-gray-50 dark:bg-[#1e1e2d]">
        <p className="text-gray-500 dark:text-gray-400">Impossible d'afficher le post associé</p>
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col h-full overflow-hidden bg-white dark:bg-[#1a1d2d] transition-colors">
      {/* En-tête du post */}
      <PostHeader comment={comment} />
      
      {/* Contenu du post */}
      <div className="flex-1 overflow-y-auto p-4">
        <div className="mb-2">
          <p className="text-sm mb-2 dark:text-gray-300">{post.content}</p>
          {post.media && post.media.length > 0 && (
            <MediaDisplay 
              media={post.media[0]} 
              platform={comment.platform} 
              videoId={comment.videoId} 
            />
          )}
        </div>
        
        {/* Section commentaires */}
        <div className="mt-3">
          <h3 className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Commentaires</h3>
          <CommentBubble comment={comment} formatTime={formatTime} />
        </div>
      </div>
      
      {/* Section de réponse */}
      <ReplySection comment={comment} />
    </div>
  );
};

export default PostView;
